/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { Localization } from 'connex-cds';
import React from 'react';
import { useGetCompanyAdmin } from '../../../../../../query-hooks/company';
import { formatTicketDateTime } from '../../formatTicketDateTime';
import { useResolvedTicketTimeZone } from '../../useResolvedTicketTimeZone';

/**
 * Formats ticket ISO datetimes via connex-utils-node-v4/dates.
 * TZ via useResolvedTicketTimeZone (ticket.origin → company-admin → localization).
 *
 * @param {{ mode?: 'date'|'time'|'datetime' }} [options]
 */
export const useFormatStatusEventDateTime = ({ mode = 'time' } = {}) => {
  const { data: companyAdmin } = useGetCompanyAdmin();
  const { userLocale } = Localization.useLocalizationContext() ?? {};
  const timeZone = useResolvedTicketTimeZone();

  const dateTimeSettings = companyAdmin?.dateTimeSettings ?? {};
  const { dateFormat, use24HourTimeFormat } = dateTimeSettings;

  return React.useCallback(
    isoDateTime =>
      formatTicketDateTime(isoDateTime, {
        dateFormat,
        use24HourTimeFormat,
        timeZone,
        mode,
        locale: userLocale,
      }),
    [dateFormat, mode, use24HourTimeFormat, timeZone, userLocale]
  );
};
